import "D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
// Vue
import Vue from 'vue';
import i18n from './i18n';
import App from './App';
// 核心插件
import d2Admin from '@/plugin/d2admin';
// store
import store from '@/store/index';
// 参数校验
import './libs/util.int';

// 菜单和路由设置
import axios from 'axios';
import router from './router';
import { menuHeader } from '@/menu';
import { frameInRoutes } from '@/router/routes';

// V-Charts
// import VCharts from 'v-charts'

// 高德地图
// import VueAMap from 'vue-amap' // 引入高德
import vRegion from 'v-region';

// 核心插件
Vue.use(d2Admin);

// V-Charts
// Vue.use(VCharts)

// 高德地图
// Vue.use(VueAMap)
Vue.use(vRegion);

// 百度地图
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'wBgTpVPfKXhJClb7PmzcO4SuXKKxSa06'
});

// 甘特图
import vGanttChart from 'v-gantt-chart';
Vue.use(vGanttChart);

// 大屏设计器
import { registerConfig as registerConfigDataRoom, $dataRoomAxios } from '@gcpaas/data-room-ui';

// 使用大屏提供的方法，进行后端服务地址注册
registerConfigDataRoom({
  httpConfigs: {
    // 这里是大屏设计器对应的后端服务地址，可以为具体值，也可以在其他地方进行配置
    baseURL: process.env.VUE_APP_API,
    // 这里是大屏文件的访问前缀，一般和后端配置的gc.starter.file.urlPrefix保持一致即可
    fileUrlPrefix: process.env.VUE_APP_UPLOAD_API
  },
  // 资源库允许上传的文件类型
  sourceExtends: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico', 'xls', 'xlsx', 'csv'],
  routers: {
    // 大屏设计路由
    designUrl: '/dataroom'
  },
  customTheme: {
    '--bs-background-1': '#fff',
    // 整体背景色
    '--bs-background-2': '#232832',
    // 布局背景色
    '--bs-el-background-1': '#151A26',
    // 组件背景色，输入框...
    '--bs-el-background-2': '#35393F',
    // 组件背景色，按钮、分页、加载...
    '--bs-el-background-3': '#303640',
    // 组件背景色，表格头部、下拉框hover...
    '--bs-el-title': '#ffffff',
    // 标题字体颜色
    '--bs-el-text': '#ffffff',
    // 一般字体颜色
    '--bs-el-color-primary': '#409EFF',
    // 样式主题色
    '--bs-el-color-primary-active': '64, 158, 255',
    // 主要激活 => rgba(64, 158, 255, 1) = #409EFF
    '--bs-el-border': 'transparent' // 边框颜色
  }
  // 此处第二个参数为自己项目中的路由实例对象
}, router);
// 将大屏的aixos实例挂载到Vue上
Vue.prototype.$dataRoomAxios = $dataRoomAxios;

// 全局混入mixin
// Vue.mixin({
//   mounted(){
//     // rem适配
//     this.setRootFontSize();
//     window.addEventListener('resize', this.setRootFontSize); // 监听窗口大小变化以重新设置字体大小
//   },
//   beforeDestroy() { // 组件销毁前移除事件监听器以避免内存泄漏
//     window.removeEventListener('resize', this.setRootFontSize);
//   },
//   methods:{
//     setRootFontSize() {
//       console.log('setRootFontSize')
//       const baseSize = 1; // 基础字体大小，可根据需要调整
//       const scale = window.innerWidth / 1920; // 根据视口宽度调整比例因子，1024可以根据需要调整为其他值以适配设计稿宽度等比例缩放。
//       document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 2)}px`; // 设置根元素字体大小，最大不超过基础字体大小的1倍（可根据需要调整）
//     }
//   }
// })

new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit('d2admin/menu/headerSet', []);
    // 初始化菜单搜索功能
    this.$store.commit('d2admin/search/init', menuHeader);
  },
  mounted: function mounted() {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow');
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load');
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get');
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen');
  }
}).$mount('#app');

// 日期格式化
Vue.prototype.dateFormat2Str = function (data) {
  if (data) {
    var time = data + '';
    if (time.length === 8) {
      return time.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    } else if (time.length === 12) {
      return time.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5');
    } else if (time.length === 14) {
      return time.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6');
    } else {
      return '';
    }
  } else {
    return '';
  }
};

// 驼峰转下划线
Vue.prototype.camelToUnderline = function (data) {
  if (data) {
    var content = data + '';
    return content.replace(/([A-Z])/g, '_$1').toLowerCase();
  } else {
    return '';
  }
};

// 拼接Get参数
Vue.prototype.joinGetParam = function (data) {
  var params = '';
  for (var key in data) {
    if (data[key]) {
      if (params.length === 0) {
        params += "?".concat(key, "=").concat(data[key]);
      } else {
        params += "&".concat(key, "=").concat(data[key]);
      }
    }
  }
  return params;
};

// 文件上传
Vue.prototype.uploadFile = function (userId, currentDate, sing, file, isFile) {
  console.log('isFile', isFile);
  // 获取文件后缀
  var lastPointIndex = file.name.lastIndexOf('.');
  var suffix = file.name.substr(lastPointIndex + 1);
  var key = userId + '/' + currentDate + '/' + Date.now() + '.' + suffix; // 创建文件路径

  var formData = new FormData();
  if (process.env.VUE_APP_UPLOAD_TYPE === 'server') {
    formData.append('name', key);
    formData.append('file', file);
    return new Promise(function (resolve, reject) {
      axios({
        url: process.env.VUE_APP_API + 'mng/file/upload',
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data; boundary = ' + new Date().getTime(),
          Authorization: localStorage.getItem('token')
        }
      }).then(function (response) {
        if (response.status === 200 && response.data.code === 200) {
          resolve(process.env.VUE_APP_API + 'mng/file/download/' + response.data.data.id);
        } else {
          // 抛出错误
          reject(response);
        }
      }).catch(function (error) {
        // 抛出异常
        reject(error);
      });
    });
  } else if (process.env.VUE_APP_UPLOAD_TYPE === 'oss') {
    formData.append('key', key);
    formData.append('OSSAccessKeyId', sing.accessId);
    formData.append('policy', sing.policy);
    formData.append('signature', sing.signature);
    formData.append('success_action_status', '200');
    formData.append('file', file);
    return new Promise(function (resolve, reject) {
      axios({
        url: process.env.VUE_APP_UPLOAD_API,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        console.log('response', process.env.VUE_APP_UPLOAD_API + key);
        if (response.status === 200) {
          // 返回上传路径
          if (isFile) {
            resolve({
              url: process.env.VUE_APP_UPLOAD_API + key,
              name: file.name
            });
          } else {
            resolve(process.env.VUE_APP_UPLOAD_API + key);
          }
        } else {
          // 抛出错误
          reject(response);
        }
      }).catch(function (error) {
        // 抛出异常
        reject(error);
      });
    });
  }
};

// 数字加逗号处理(每三位加逗号)
Vue.prototype.toThousands = function () {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return num.toString().replace(/\d+/, function (n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  });
};

// 按钮权限
Vue.prototype.buttonPerms = function (key) {
  var operationPermission = localStorage.getItem('operationPermission') ? JSON.parse(localStorage.getItem('operationPermission')) : {};
  // console.log('operationPermission',operationPermission,key,localStorage.getItem('userId'))
  if (localStorage.getItem('userId') == '19901001') {
    return true;
  }
  return operationPermission[key] || false;
};

// 演示模式配平时间
Vue.prototype.$timeSlot = function (val) {
  console.log('new Date().valueOf() - val - 3600000', new Date().valueOf() - val - 3600000);
  return new Date().valueOf() - val - 3600000;
};

// 高德地图
// VueAMap.initAMapApiLoader({
//   key: process.env.VUE_APP_AMAP_KEY
//   // 插件集合
//   , plugin: [
//     'AMap.Geolocation' // 定位空间，用来获取和展示用户主机所在的经纬度位置
//     , ' AMap.Autocomplete ' // 输入提示插件
//     , ' AMap.PlaceSearch ' // POI搜索插件
//     , ' AMap.Scale ' // 右下角缩略图插件，比例尺
//     , ' AMap.OverView ' // 地图鹰眼插件
//     , ' AMap.ToolBar ' // 地图工具条
//     , ' AMap.MapType ' // 类别切换空间，实现默认图层与卫星图，实施交通层之间切换的控制
//     , ' AMap.PolyEditor ' // 编辑 折线多边形
//     , ' AMap.CircleEditor '
//     , 'AMap.Geocoder' // 地图编码
//   ]
// })

window._AMapSecurityConfig = {
  securityJsCode: process.env.VUE_APP_AMAP_SECURITY_KEY
};